import { IConfig } from '@cian/config/shared';
import { IHttpApi } from '@cian/http-api/shared';
import { ILogger } from '@cian/logger/shared';
import { TDeviceType } from '@cian/ui-kit/types';

// eslint-disable-next-line import-x/no-restricted-paths
import type { getHeaderMicrofrontendApi } from '../../browser/utils/getHeaderMicrofrontendApi';

export interface IApplicationContextCustom {
  deviceType: TDeviceType;
  userAgent: string | null;
  objectId: number;
  subdomain: string;
  applicationType: EApplicationType;
  headerFrontendApi: ReturnType<typeof getHeaderMicrofrontendApi> | null;
}

export enum EApplicationType {
  Default = 'default',
  Dailyrent = 'dailyrent',
  Newbuildings = 'newbuildings',
}

export interface IApplicationContext {
  config: IConfig;
  httpApi: IHttpApi;
  logger: ILogger;
  custom: IApplicationContextCustom;
}
